// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const WalletMoneyIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "WalletMoney/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.475 13.4c-.2 2.225-1.808 3.683-4.142 3.683h-7.5a4.168 4.168 0 0 1-4.166-4.166V7.083c0-2.266 1.366-3.85 3.491-4.116.217-.034.442-.05.675-.05h7.5c.217 0 .425.008.625.041 1.992.234 3.342 1.625 3.517 3.642a.409.409 0 0 1-.417.442h-1.291c-.8 0-1.542.308-2.075.858a2.931 2.931 0 0 0-.875 2.35c.133 1.517 1.466 2.708 3.05 2.708h1.191c.242 0 .442.2.417.442Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.333 9.142v1.716a.855.855 0 0 1-.833.85h-1.633c-.9 0-1.725-.658-1.8-1.558-.05-.525.15-1.017.5-1.358a1.66 1.66 0 0 1 1.2-.5H17.5a.856.856 0 0 1 .833.85Z"
}));
export default WalletMoneyIcon;